import React, { FC } from 'react';
import { Seo, useSeoDefaults } from '@funtech-int/yango-shared';

import { mainRoute } from '@/scenarios/home/routes';
import { useI18n } from '@/shared/i18n/seo/useI18n';

import { useSiteNameData } from '../../hooks/useSiteNameData';

export const MainPageHead: FC = () => {
    const intl = useI18n();
    const { seoSiteName } = useSeoDefaults();
    const location = mainRoute();

    const title = intl('home_seo_title', { brandName: seoSiteName });
    const description = intl('home_seo_description');

    const structuredData = [{ id: 'site-name-data', data: useSiteNameData() }];

    return (
        <>
            <Seo.BasicMeta seoTitle={title} seoDescription={description} location={location} />
            <Seo.OgWebsiteMeta ogTitle={title} ogDescription={description} location={location} />
            <Seo.TwitterMeta twitterDescription={description} />
            <Seo.StructuredData scripts={structuredData} />
        </>
    );
};
